import React from "react";

const ModalInstallApp = (params) => {
  return (
    <div>
      <div className="container mt-5 text-center">
        <button
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#invitacionApp"
          id="btnOpenModalInstallApp"
          style={{display: 'none'}}
        >
        </button>
      </div>
      <div
        className="modal fade"
        id="invitacionApp"
        tabIndex="-1"
        aria-labelledby="invitacionAppLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content dialogo-transparente">
            <div className="modal-header d-flex justify-content-center">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Cerrar"
              ></button>
            </div>
            <div className="modal-body text-center">
              <img
                src={
                  process.env.REACT_APP_BASE_URL +
                  "Imagenes_config/logo_transpa1.png"
                }
                alt="Logo de la App"
                className="logo-app"
                style={{ marginTop: "-2em" }}
              />
              <h3 style={{ fontSize: "1.2em", marginTop: '-0.5em' }}>Instala la App</h3>
              <p>
                Descubre una experiencia más rápida y optimizada directamente en
                tu dispositivo.
              </p>
            </div>
            <div
              style={{ marginTop: "-1.5em" }}
              className="modal-footer d-flex justify-content-center"
            >
              <button onClick={params.handleInstallClick} type="button" className="btn btn-success">
                <span style={{ display: "flex" }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-download"
                    viewBox="0 0 16 16"
                    style={{marginTop: '0.2em', marginRight: '0.3em'}}
                  >
                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                  </svg>
                  Instalar app
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInstallApp;
